import {
  MicrophoneIcon,
  MicrophoneSlashIcon,
} from "@/components/icons/phosphor";
import { Button } from "@/components/ui/button";
import {
  LevelMeter,
  LevelMeterBar,
  LevelMeterChannel,
  LevelMeterChannels,
  LevelMeterClip,
  LevelMeterHold,
  LevelMeterTrack,
  LevelMeterValue,
} from "@/components/ui/level-meter";
import { useAudioAnalyser } from "@/hooks/use-audio-analyser";
import { useMicrophone } from "@/hooks/use-microphone";

export const LevelMeterMicrophone = () => {
  const microphone = useMicrophone();
  const analyser = useAudioAnalyser(() => microphone.stream);
  const listening = () => microphone.status === "active";

  return (
    <div class="flex w-full max-w-md flex-col gap-4">
      <LevelMeter aria-label="Microphone level" source={analyser.meter}>
        <LevelMeterChannels>
          <LevelMeterChannel>
            <LevelMeterTrack>
              <LevelMeterBar />
              <LevelMeterHold />
            </LevelMeterTrack>
          </LevelMeterChannel>
        </LevelMeterChannels>
        <LevelMeterValue />
        <LevelMeterClip />
      </LevelMeter>
      <Button
        class="self-start"
        onClick={() => {
          if (listening()) microphone.stop();
          else void microphone.start();
        }}
        size="sm"
        variant="outline"
      >
        {listening() ? (
          <MicrophoneSlashIcon data-icon="inline-start" />
        ) : (
          <MicrophoneIcon data-icon="inline-start" />
        )}
        {listening() ? "Stop microphone" : "Use my microphone"}
      </Button>
    </div>
  );
};
